import CourseDesigner from './components/CourseDesigner';
import { Analytics } from '@vercel/analytics/react';
import './index.css';

function App() {
  return (
    <div className="App">
      <CourseDesigner />
      <Analytics />
    </div>
  );
}

export default App; 